import { default as RenderComponent } from "@/pages/c/[locale]/[[...paths]]";
import { getServerSideProps as getServerSidePropsForProperties } from "@/pages/c/[locale]/properties/[[...paths]]";

export { getServerSidePropsForProperties as getServerSideProps };
export default RenderComponent;
